import React, { Component } from 'react';
import $ from 'jquery';
import {ApiClient} from '../libs/apiClient';
import moment from "moment";
import { decodeText } from '../libs/utils/Const';
import InventoryStockModal from './InventoryStockModal';
import { CSVLink, CSVDownload } from "react-csv";
import { CURRENCY } from '../libs/utils/Const';

let apiClient = ApiClient.getInstance();
const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class InventoryReportsModal extends Component{
    csvLink= React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            ListItemsGroup: [],
            Articulos: [],
            Asiento: [],
            Almacenes : [],
            AlmacenesArray : [],
            FechaIn : '',
            Fechafi : '',
            ItemIn : '',
            ItemFi : '',
            Group : '',
            newDatas : [],
            flag : '',
            checkbox : false,
            wareHouses : '',
            dataCsv: [],
        };
    }

    componentDidMount = () =>{
        let Desde = moment(new Date()).format('YYYY-MM-DD');
        let Hasta = moment(new Date()).format('YYYY-MM-DD');

        document.getElementById('PorArticulos').checked = true;
        //document.getElementById('ChkOcultar').checked = true;

        this.setState({
            FechaIn : Desde,
            FechaFi: Hasta,
            ItemIn : '1303',
            ItemFi: 'XXX',
            Group: 'ALL'
        })

    }

    componentWillReceiveProps = async ()=>{

        let data=null;
        data={
            ItemCode: "CFMB001",
            TransferType: "I",
            whsCode: ""
        }

        let GroupsItemData = await apiClient.getGroupsItemData();
        let GroupsItems = await apiClient.getArticulos();
        let getAlmacenResponse = await apiClient.getWarehouseList(data);
        getAlmacenResponse.data.map((whs)=>{
            whs.selected= false;
        });

        this.setState({
            ListItemsGroup: GroupsItemData.data.GrupoArticulo,
            Articulos : GroupsItems.data.Articulo,
            Almacenes : getAlmacenResponse.data
        })
    }

    toggleDocumentSelected = (id) => {
      const {Almacenes}= this.state;
       let newAlmacen= Almacenes;
        newAlmacen[id].selected=!newAlmacen[id].selected;
        this.setState({
            Almacenes:newAlmacen
        });
    };

    toggleDocumentSelectedAll = (action) => {
        const {Almacenes,checkbox} = this.state;
        let check = !checkbox;
        Almacenes.map((whs) => {
            whs.selected = check;
        });
        this.setState({
            Almacenes: Almacenes,
            checkbox : check
        });
    };

    selectDocDueDate = event => {
        let fechain = event.nativeEvent.target.value;
        this.setState({
            FechaIn : fechain
        })
    };

    selectDocDate = event => {
        let fechafi = event.nativeEvent.target.value;
        this.setState({
            FechaFi : fechafi
        })
    };

    selectData = (event, option) => {

        if (option == 1) {
            this.setState({
                ItemIn: event.nativeEvent.target.value,
            })
        }

        if (option == 2) {
            this.setState({
                ItemFi: event.nativeEvent.target.value,
            })
        }

        if (option == 3) {
            this.setState({
                Group: event.nativeEvent.target.value,
            })
        }
    };

    closeConfirm = async () => {
        document.getElementById('ChkAlmacenes').checked = false;
        document.getElementById('ChkTransacciones').checked = false;
        document.getElementById('ChkOcultar').checked = false;

        $('#InventoryReportsModal').modal('hide');
    }

    openInventoryReportsModal = async () =>{
        const {enableSpinner,showAlert} = this.props;
        const {Almacenes,checkbox,FechaIn,FechaFi,ItemIn,ItemFi,Group}= this.state;

        let FechaInicial = moment(FechaIn).format('YYYYMMDD');
        let FechaFinal = moment(FechaFi).format('YYYYMMDD');
        let getAuditoryStock = '';
        let bandera = false;
        let wareHouses = '';
        if(!checkbox){
            Almacenes.map((whs)=>{
                if(whs.selected){
                    wareHouses += `'${whs.WhsCode}',`;
                }
            });
        }
        wareHouses = wareHouses.substring(0, wareHouses.length -1);
        

        enableSpinner(true);
        // if(document.getElementById('CheckAll').checked){
        //     wareHouses = 'ALL';
        // }
        if(document.getElementById('PorArticulos').checked && wareHouses !=''){
            let data={
                Tipo : 'HeadersAll',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                GroupLis : Group,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                Almacenes : wareHouses
            };
            getAuditoryStock = await apiClient.getAuditoryWhs(data);
        }
        if(document.getElementById('ChkAlmacenes').checked && document.getElementById('PorArticulos').checked) {
            let data={
                Tipo : 'HeadersGroup',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                GroupLis : Group
            };
            getAuditoryStock = await apiClient.getAuditoryStock(data);
        }
        if(document.getElementById('ChkTransacciones').checked && document.getElementById('PorArticulos').checked) {
            let data={
                Tipo : 'HeadersTrans',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal
            };
            getAuditoryStock = await apiClient.getAuditoryStock(data);
        }
        if(document.getElementById('PorArticulos').checked && wareHouses ==='') {
            let data={
                Tipo : 'Headers',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                GroupLis : Group,
                Almacenes : wareHouses
            };
            getAuditoryStock = await apiClient.getAuditoryStock(data);
        }
        // if(document.getElementById('ChkTransacciones').checked && document.getElementById('ResumirCuentas').checked) {
        //     bandera = true;
        //     let data={
        //         Tipo : 'HeadersAccountTrans',
        //         FechaIn : FechaInicial,
        //         FechaFi : FechaFinal,
        //         ItemInicial : ItemIn,
        //         ItemFinal : ItemFi
        //     };

        //     getAuditoryStock = await apiClient.getAuditoryStock(data);
        // }
        // if(document.getElementById('ResumirCuentas').checked) {
        //     bandera = true;
        //     let data={
        //         Tipo : 'HeadersAccount',
        //         FechaIn : FechaInicial,
        //         FechaFi : FechaFinal,
        //         ItemInicial : ItemIn,
        //         ItemFinal : ItemFi
        //     };

        //     getAuditoryStock = await apiClient.getAuditoryStock(data);
        // }

        enableSpinner(false);
        if (getAuditoryStock.data.length === 0) {
            showAlert({type: 'warning', message: 'No hay información disponible'});
            wareHouses = '';
            return;
        }
        $('#InventoryStockModal').modal('show');

        this.setState({
            newDatas: getAuditoryStock.data,
            flag : bandera,
            wareHouses : wareHouses,
            Group : Group
        });
    }

    onChangeValue(event) {

        if(document.getElementById('PorArticulos').checked) {
            document.getElementById('ChkAlmacenes').disabled = false;
            document.getElementById('ChkTransacciones').disabled = false;
            document.getElementById('ChkOcultar').disabled = false;
            document.getElementById('ChkAlmacenes').checked = false;
            document.getElementById('ChkTransacciones').checked = false;
            //document.getElementById('ChkOcultar').checked = false;

        }else if(document.getElementById('ResumirCuentas').checked) {
            document.getElementById('ChkAlmacenes').disabled = true;
            //document.getElementById('ChkTransacciones').disabled = true;
            document.getElementById('ChkOcultar').disabled = true;
            document.getElementById('ChkAlmacenes').checked = false;
            document.getElementById('ChkTransacciones').checked = false;
            //document.getElementById('ChkOcultar').checked = false;
        }
      }

    generateCsv= async () => {
        const {enableSpinner,showAlert} = this.props;
        const {Almacenes,checkbox,FechaIn,FechaFi,ItemIn,ItemFi,Group}= this.state;
        
        let RadioItems = document.getElementById('PorArticulos').checked;
        let FechaInicial = moment(FechaIn).format('YYYYMMDD');
        let FechaFinal = moment(FechaFi).format('YYYYMMDD');
        let bandera = false;
        let resposnerCsv;
        let wareHouses = '';
        if(!checkbox){
            Almacenes.map((whs)=>{
                if(whs.selected){
                    wareHouses += `'${whs.WhsCode}',`;
                }
            });
        }
        wareHouses = wareHouses.substring(0, wareHouses.length -1);
        
        let check = document.getElementById('ChkOcultar').checked;
        
        enableSpinner(true);

        if(wareHouses!='ALL' && RadioItems && wareHouses !='' && document.getElementById('ChkAlmacenes').checked){
            let data={
                Tipo : 'HeadersGroupsAll',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                GroupLis : Group,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                Almacenes : wareHouses
            };
            resposnerCsv = await apiClient.getAuditoryWhs(data);
        }

        if(wareHouses!='ALL' && RadioItems && wareHouses !='' && document.getElementById('ChkTransacciones').checked){
            let data={
                Tipo : 'HeadersTransAll',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                GroupLis : Group,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                Almacenes : wareHouses
            };
            resposnerCsv = await apiClient.getAuditoryWhs(data);
        }
        if(wareHouses !='' && RadioItems && document.getElementById('ChkOcultar').checked){
            let data={
                Tipo : 'HeadersHideAll',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                GroupLis : Group,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                Almacenes : wareHouses
            };
            resposnerCsv = await apiClient.getAuditoryWhs(data);
        }
        if(wareHouses!='ALL' && RadioItems && wareHouses !='' && !document.getElementById('ChkOcultar').checked && !document.getElementById('ChkTransacciones').checked && !document.getElementById('ChkAlmacenes').checked){
            
            let data={
                Tipo : 'HeadersAll',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                GroupLis : Group,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                Almacenes : wareHouses
            };
            resposnerCsv = await apiClient.getAuditoryWhs(data);
        }
        //Articulos con FILTRO
        if(wareHouses ==='' && RadioItems && document.getElementById('ChkOcultar').checked) {
            let data={
                Tipo : 'HeaderHideExcel',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                GroupLis : Group
                //Almacenes : wareHouses
            };
            resposnerCsv = await apiClient.getAuditoryStock(data);
        }
        //Articulos sin FILTRO
        if(wareHouses ==='' && RadioItems && !document.getElementById('ChkOcultar').checked && !document.getElementById('ChkTransacciones').checked && !document.getElementById('ChkAlmacenes').checked) {
            let data={
                Tipo : 'HeaderExcel',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                GroupLis : Group,
                Almacenes : wareHouses
            };
            resposnerCsv = await apiClient.getAuditoryStock(data);
            
        }
        if(wareHouses ==='' && RadioItems && document.getElementById('ChkTransacciones').checked) {
            let data={
                Tipo : 'HeaderTransExcel',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                GroupLis : Group,
                Almacenes : wareHouses
            };
            resposnerCsv = await apiClient.getAuditoryStock(data);
        }
        if(wareHouses ==='' && RadioItems && document.getElementById('ChkAlmacenes').checked) {
            let data={
                Tipo : 'HeaderGroupExcel',
                FechaIn : FechaInicial,
                FechaFi : FechaFinal,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
                GroupLis : Group,
                Almacenes : wareHouses
            };
            resposnerCsv = await apiClient.getAuditoryStock(data);
        }

        resposnerCsv.data.map(function(auditory){
            
            if(auditory.Documento === 10000071){
                auditory.Documento = 'Contabilización de inventario';
            }
            if(auditory.Documento === 132){
                auditory.Documento = 'Factura de corrección';
            }
            if(auditory.Documento === 13){
                auditory.Documento = 'Factura de deudores';
            }
            if(auditory.Documento === 14){
                auditory.Documento = 'Nota de crédito de deudores';
            }
            if(auditory.Documento === 15){
                auditory.Documento = 'Entrega';
            }
            if(auditory.Documento === 162){
                auditory.Documento = 'Revaluación de inventario';
            }
            if(auditory.Documento === 16){
                auditory.Documento = 'Devoluciones';
            }
            if(auditory.Documento === 18){
                auditory.Documento = 'Factura de acreedores';
            }
            if(auditory.Documento === 19){
                auditory.Documento = 'Nota de crédito de acreedores';
            }
            if(auditory.Documento === 20){
                auditory.Documento = 'Entrada de mercancías';
            }
            if(auditory.Documento === 21){
                auditory.Documento = 'Devolución de mercancías';
            }
            if(auditory.Documento === 310000001){
                auditory.Documento = 'Cantidad inicial';
            }
            if(auditory.Documento === 58){
                auditory.Documento = 'Actualización de existencias';
            }
            if(auditory.Documento === 59){
                auditory.Documento = 'Entrada de mercancías';
            }
            if(auditory.Documento === 60){
                auditory.Documento = 'Salida de mercancías';
            }
            if(auditory.Documento === 67){
                auditory.Documento = 'Transferencia de inventario';
            }
            if(auditory.Fecha_de_Sistema != ''){
                auditory.Fecha_de_Sistema = moment(auditory.Fecha_de_Sistema).format('YYYY-MM-DD');
            }
            if(auditory.Fecha_de_Contabilización != ''){
                auditory.Fecha_de_Contabilización = moment(auditory.Fecha_de_Contabilización).format('YYYY-MM-DD');
            }
            
            return auditory;
        });

        enableSpinner(false);
            

        if (!Array.isArray(resposnerCsv.data)) {
            showAlert({type: 'error', message: 'Ocurrió un error al consultar la Información'});
            return;
        }

        if (resposnerCsv.data.length === 0) {
            showAlert({type: 'info', message: 'No hay Información por mostrar'});
            return;
        }
            let datas= resposnerCsv.data || [];
            this.setState({ 
                dataCsv: datas,
                Almacenes : Almacenes 
            })
            setTimeout(() => {
                this.csvLink.current.link.click();
        }, 500);
    }

    render() {
        const {ListItemsGroup,Articulos,Almacenes,checkboxArray,FechaIn,FechaFi,ItemIn,ItemFi,newDatas,flag,Group,wareHouses,dataCsv} = this.state;
        const {enableSpinner,showAlert} = this.props;

        return (

            <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="InventoryReportsModal" style={{zIndex: 91}}
                 role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                     
                     <CSVLink 
                    data={dataCsv} 
                    filename ={"InformeAuditoriastock.csv"}                
                    className="hidden"
                    ref={this.csvLink}
                    target="_blank"/>

                      <InventoryStockModal
                      FechaInicial = {FechaIn}
                      FechaFinal = {FechaFi}
                      enableSpinner = {enableSpinner}
                      ItemIn = {ItemIn}
                      ItemFi = {ItemFi}
                      newDatas = {newDatas}
                      showAlert={showAlert}
                      bandera = {flag}
                      wareHouses = {wareHouses}
                      Group = {Group}
                      />
                <div className="modal-dialog modal-xl " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Informe de auditoría de stock: Criterios de selección
                            </h4>
                            <button type="button" className="close" onClick={this.closeConfirm} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="container">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{marginBottom: 0}}>
                                                {/*HEADER*/}
                                                <div className="row" style={{paddingRight: 0}}>
                                                    {/*Primer columna*/}
                                                    <div className="col-sm col">
                                                        {/*FECHA DESDE*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1"> Desde</span>
                                                            </div>
                                                            <input
                                                                    id="fechaInicio"
                                                                    style={{
                                                                        important: true,
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    className="form-control"
                                                                    type='date'
                                                                    placeholder="Fecha min"
                                                                    autoComplete="off"
                                                                    value={FechaIn ? FechaIn : ''}
                                                                    onChange={this.selectDocDueDate}
                                                                />
                                                        </div>
                                                        {/*FECHA HASTA:*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1"> Hasta</span>
                                                            </div>
                                                            <input
                                                                    id="fechaFin"
                                                                    style={{
                                                                        important: true,
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    className="form-control"
                                                                    type='date'
                                                                    placeholder="Fecha min"
                                                                    autoComplete="off"
                                                                    value={FechaFi ? FechaFi : ''}
                                                                    onChange={this.selectDocDate}
                                                                />
                                                        </div>
                                                    </div>

                                                    {/*Segunda columna*/}
                                                    <div className="col-sm col">
                                                        {/*CODIGO DESDE*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Código-Desde</span>
                                                            </div>
                                                            <select name="select" className="form-control" id="selectItemIn"
                                                            value={this.state.ItemIn}
                                                                        style={{color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, width: 150}}
                                                                        onChange={(event) => this.selectData(event, 1)}>

                                                                    {Articulos.map(group => {
                                                                        return (
                                                                            <option value={group.ItemCode}>{group.ItemCode}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                        </div>
                                                        {/*CODIGO HASTA*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Código-Hasta</span>
                                                            </div>
                                                            <select name="select" className="form-control" id="selectItemFi"
                                                                value={this.state.ItemFi}
                                                                        style={{color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, width: 150}}
                                                                        onChange={(event) => this.selectData(event, 2)}>
                                                                    {Articulos.map(group => {
                                                                        return (
                                                                            <option value={group.ItemCode}>{group.ItemCode}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                        </div>
                                                        {/*GRUPO*/}
                                                        {/* <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Grupo</span>
                                                            </div>
                                                            <select name="select" className="form-control" id="selectGroup"
                                                                value={this.state.Group}
                                                                    style={{color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, width: 150}}
                                                                    onChange={(event) => this.selectData(event, 3)}>
                                                                {/* <option value="NONE"></option> */}

                                                                {/* {ListItemsGroup.map(group => {
                                                                    return (
                                                                        <option value={group.ItmsGrpCod}>{group.ItmsGrpNam}</option>
                                                                    )
                                                                })} */}
                                                                {/*<option value="ALL">TODOS</option>
                                                            </select>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                {/*BODY*/}
                                                <div style={{marginBottom: 30}}>
                                                    <div style={{height: 450, overflow: 'auto'}}>
                                                        <table
                                                            // id="dataTableDocuments"
                                                            className="display"
                                                            style={{width: '100%',height:'200', marginBottom: 40, marginRight: -3000}}>
                                                            <thead className="table-header-yellow">
                                                                <tr style={{textAlign: "center"}}>
                                                                    <td className="sticky-column sticky-header" style={{width:'30',backgroundColor: '#d2ab24'}}>
                                                                        <input type="checkbox" style={{minWidth: '100%', width:'15px', height:'15px'}} id="CheckAll"
                                                                                    onChange={(event) => this.toggleDocumentSelectedAll(event.target.checked)}/>
                                                                    </td>
                                                                    <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                        Código
                                                                    </td>
                                                                    <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                        Nombre
                                                                    </td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {/* Filas de tabla  */}
                                                                {Almacenes.map((item, index) => {
                                                                    return (
                                                                        <tr style={{
                                                                            maxHeight: 10,
                                                                            paddingTop: 7,
                                                                            paddingBottom: 7,
                                                                            color: 'black',
                                                                            backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : 'transparent'}}>

                                                                            {/*CODIGO SN   onChange={(event) => checkbox.selectOne(event.target.checked)}   onClick={event => this.openDetails(event,index)}*/}
                                                                            <td className="overflow-visible">
                                                                                <input type="checkbox" checked={item.selected} style={{minWidth: '100%', width:'15px', height:'15px'}}
                                                                                    onChange={() => this.toggleDocumentSelected(index)}/>

                                                                            </td>
                                                                            {/*NOMBRE SN*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.WhsCode}
                                                                                </td>
                                                                            {/*CUENTA ASOCIADA*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {decodeText(item.WhsName)}
                                                                                </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="tab-content" id="myTabContent" style={{textAlign: 'left'}}>
                                                    <div
                                                        className="tab-pane fade show active "
                                                        id="transfersControl"
                                                        role="tabpanel"
                                                        aria-labelledby="nav-home-tab-One"><br></br>
                                                        <div className="card col-md-12 col-sm-12" style={{background: 'transparent'}}>
                                                            <div className="card-body">
                                                                <h5 className="card-title" style={{color: '#EABF28'}}>Visualizar</h5>
                                                                {/*  onChange={this.onChangeValue} */}
                                                                <div >
                                                                    <div className="form-check">
                                                                        <input type="radio" className="form-check-input" id="PorArticulos" name="materialExampleRadios" style ={{width:'15px', height:'15px'}}/>
                                                                        &nbsp;
                                                                        <label className="form-check-label" htmlFor="PorArticulos"><h6>Por artículos</h6></label>
                                                                    </div>
                                                                    {/* <div className="form-check">
                                                                        <input type="radio" className="form-check-input" id="ResumirCuentas" name="materialExampleRadios" style ={{width:'15px', height:'15px'}}/>
                                                                        &nbsp;
                                                                        <label className="form-check-label" for="materialUnchecked"><h6>Resumir por cuentas</h6></label>
                                                                    </div> */}
                                                                </div>
                                                                    <br></br>
                                                                <div className="form-check">
                                                                    <input type="checkbox" className="form-check-input" id="ChkAlmacenes" name="materialExampleRadios" style={{ width: '15px', height: '15px' }} />
                                                                    &nbsp;
                                                                    <label className="form-check-label" htmlFor="ChkAlmacenes"><h6>Grupo por almacenes</h6></label>
                                                                </div>
                                                                <div className="form-check mb-2">
                                                                    <input type="checkbox" className="form-check-input" id="ChkTransacciones" name="materialExampleRadios" style={{ width: '15px', height: '15px' }} />
                                                                    &nbsp;
                                                                    <label className="form-check-label" htmlFor="ChkTransacciones">
                                                                        <h6>
                                                                            <span className="d-none d-xl-inline">Visualizar SI para artículos/cuentas sin transacciones</span>
                                                                            <span className="d-inline d-xl-none">Sin transacciones</span>
                                                                        </h6>
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input type="checkbox" className="form-check-input" id="ChkOcultar" name="materialExampleRadios" style={{ width: '15px', height: '15px' }} />
                                                                    &nbsp;
                                                                    <label className="form-check-label" htmlFor="ChkOcultar">
                                                                        <h6>
                                                                            <span className="d-none d-xl-inline">Ocultar artículos con una cantidad acumulada equivalente a cero</span>
                                                                            <span className="d-inline d-xl-none">Ocultar cantidad acumulada cero</span>
                                                                        </h6>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeConfirm}>Cerrar</button>
                            <button className="btn btn-success text-white btn-outline-secondary mr-sm-2 btnNuevo" style={{borderColor: "#A7A6A5"}}  onClick={this.generateCsv}> <i className="fa fa-file-excel-o mr-sm-1"></i> Generar Excel </button>
                            {/* <button type="button" className="btn botonCorrect text-black" onClick={this.openInventoryReportsModal}>OK</button> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default InventoryReportsModal;